export default {
  // Login
  "login.title": "Kirjaudu sisään",
  "login.register": "Rekisteröidy",
  "login.email": "Sähköposti",
  "login.password": "Salasana",
  "login.button": "Kirjaudu",
  "login.powered_by": "Kirjautuminen:",
  "register.button": "Rekisteröidy",
  "register.confirm_password": "Vahvista salasana",
  "register.passwords_not_match": "Salasanat eivät täsmää",
  "login.forgot_password": "Unohditko salasanan?",
  "login.reset_password_title": "Nollaa salasana",
  "login.reset_password_instructions": "Syötä sähköpostiosoitteesi, niin lähetämme sinulle linkin salasanan nollaamiseen.",
  "login.reset_password_sent": "Salasanan nollauslinkki lähetetty! Tarkista sähköpostisi ja seuraa linkkiä nollataksesi salasanasi.",
  "login.send_reset_link": "Lähetä nollauslinkki",
  "login.email_required": "Syötä sähköpostiosoitteesi",

  // Registration
  "registration.welcome": "Tervetuloa",
  "registration.no_tenant_access": "Sinulla ei ole pääsyä mihinkään yritykseen. Luo uusi yritys tai pyydä pääsyä olemassa olevaan.",
  "registration.create_new_tenant": "Luo uusi yritys",
  "registration.request_access": "Pyydä pääsyä olemassa olevaan yritykseen",
  "registration.or": "tai",
  "registration.logout": "Kirjaudu ulos ja käytä toista tiliä",
  "registration.create_tenant_title": "Luo uusi yritys",
  "registration.create_tenant_description": "Luo uusi yritys aloittaaksesi sovelluksen käytön. Sinusta tulee tämän yrityksen ylläpitäjä.",
  "registration.company_name": "Yrityksen nimi",
  "registration.company_name_placeholder": "Syötä yrityksen nimi",
  "registration.company_name_required": "Yrityksen nimi on pakollinen",
  "registration.business_id": "Y-tunnus",
  "registration.business_id_placeholder": "esim. 1234567-8",
  "registration.business_id_required": "Y-tunnus on pakollinen",
  "registration.create_tenant_button": "Luo yritys",
  "registration.tenant_created": "Yritys luotu onnistuneesti!",
  "registration.create_error": "Yrityksen luonti epäonnistui. Yritä uudelleen.",
  "registration.request_access_title": "Pyydä pääsyä",
  "registration.request_access_description": "Syötä yrityksen tunnus pyytääksesi pääsyä. Ylläpitäjä käsittelee pyyntösi.",
  "registration.tenant_id": "Yrityksen tunnus",
  "registration.tenant_id_required": "Yrityksen tunnus on pakollinen",
  "registration.message_optional": "Viesti (valinnainen)",
  "registration.message_placeholder": "Kerro miksi tarvitset pääsyn...",
  "registration.send_request": "Lähetä pyyntö",
  "registration.request_sent": "Pääsypyyntö lähetetty onnistuneesti!",
  "registration.request_error": "Pyynnön lähetys epäonnistui. Tarkista yrityksen tunnus ja yritä uudelleen.",
  "registration.coa_type": "Tilikartta",
  "registration.coa_real_estate": "Kiinteistö",
  "registration.coa_business": "Yritys",
  "registration.coa_association": "Yhdistys",
  "registration.terms_accept": "Hyväksyn",
  "registration.terms_link": "käyttöehdot",
  "registration.terms_required": "Sinun täytyy hyväksyä käyttöehdot jatkaaksesi",

  // Company Info Setup
  "setup.title": "Täydennä yritystiedot",
  "setup.description": "Syötä pakolliset yritystiedot jatkaaksesi.",
  "setup.company_info": "Yrityksen tiedot",
  "setup.company_name": "Yrityksen nimi",
  "setup.address": "Osoite",
  "setup.bank_info": "Pankkitili",
  "setup.email": "Yrityksen sähköposti",
  "setup.street_address": "Katuosoite",
  "setup.zip_code": "Postinumero",
  "setup.city": "Kaupunki",
  "setup.country": "Maa",
  "setup.currency": "Valuutta",
  "setup.iban": "IBAN",
  "setup.bic": "BIC/SWIFT",
  "setup.bank_name": "Pankin nimi",
  "setup.submit": "Viimeistele asetukset",
  "setup.required": "Tämä kenttä on pakollinen",
  "setup.success": "Yritystiedot tallennettu onnistuneesti!",
  "setup.error": "Yritystietojen tallennus epäonnistui. Yritä uudelleen.",
};
